export default __webpack_public_path__ + "static/media/ethereum.2c13b545.png";